@if (showSpinner) {
  <div class="spinner-border loader alfalaval-blue-color spinner-center"></div>
}
<h3>Items</h3>
<div style="width: 100%;">Enter at least 3 characters in order to filter.</div>
@if (validationMessage) {
  <div class="alert alert-warning" role="alert" style="margin-top: 10px; margin-bottom: 10px;">
    {{ validationMessage }}
  </div>
  }@if (successMessage) {
  <div class="alert alert-success alert-dismissible fade show" role="alert" style="margin-top: 10px; margin-bottom: 10px;">
    {{ successMessage }}
  </div>
}
@if (error && errorMessage) {
  <div class="alert alert-danger alert-dismissible fade show" role="alert" style="margin-top: 10px; margin-bottom: 10px;">
    {{ errorMessage }}
  </div>
}
@if (itemsService.queryError$ | async; as queryError) {
  <div class="alert alert-danger" role="alert" style="margin-top: 10px; margin-bottom: 10px;">
    {{ queryError }}
  </div>
}
<div style="width: 100%;">
  
<kendo-grid 
      [data]="view | async"
      [loading]="itemsService.loading"
      [skip]="state.skip"
      [pageSize]="state.take"
      [skip]="state.skip"
      [pageable]="pageableSettings"
      [filterable]="'row'"
      [resizable]="true"
      [filter]="filter"
      (filterChange)="filterChange($event)"
      (pageChange)="pageChange($event)"
      [selectable]="isAdmin ? selectableSettings : false"
      [kendoGridSelectBy]="'itemId'"
      [(selectedKeys)]="selectedItemIds"
      (selectionChange)="onSelectionChange($event)"
      (detailExpand)="onDetailExpand($event)">
      <ng-template kendoGridToolbarTemplate position="top">
        <div class="d-flex justify-content-end gap-2 w-100">
          @if (isAdmin) {
            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="addItem()" title="Add item">
              <i class="fa fa-plus" aria-hidden="true"></i> Add item
            </button>
          }
          <button class="btn btn-outline-secondary btn-sm" (click)="refreshData()" title="Refresh">
            <i class="fa fa-rotate-right" aria-hidden="true"></i> Refresh
          </button>
        </div>
      </ng-template>
      <ng-template kendoGridDetailTemplate let-dataItem>
        <supplier-detail
          [suppliers]="suppliersMap.get(dataItem.itemId) ?? []"
          [loading]="loadingSuppliers.has(dataItem.itemId)"
          [error]="supplierErrorMap.get(dataItem.itemId) ?? ''">
        </supplier-detail>
      </ng-template>
      <ng-template kendoGridLoadingTemplate>
        <div class="d-flex justify-content-center align-items-center" style="height: 100%;">
          <div class="spinner-border alfalaval-blue-color" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </ng-template>
      <kendo-grid-checkbox-column [width]="30" [hidden]="!isAdmin" [showSelectAll]="true">
      </kendo-grid-checkbox-column>
      <kendo-grid-column field="itemId" title="Item Id">
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
          <kendo-grid-string-filter-cell
            [column]="column"
            [filter]="filter"
            operator="contains"
            [showOperators]="true">
          </kendo-grid-string-filter-cell>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="description" title="Description">
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
          <kendo-grid-string-filter-cell
            [column]="column"
            [filter]="filter"
            operator="contains"
            [showOperators]="false">
          </kendo-grid-string-filter-cell>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="detailedDescription" title="Detailed description">
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
          <kendo-grid-string-filter-cell
            [column]="column"
            [filter]="filter"
            operator="contains"
            [showOperators]="false">
          </kendo-grid-string-filter-cell>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="itemDataResponsible" title="Item owner" [width]="100">
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
          <kendo-grid-string-filter-cell
            [column]="column"
            [filter]="filter"
            operator="contains"
            [showOperators]="false">
          </kendo-grid-string-filter-cell>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="itemState" title="Item state" [width]="80">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ getItemStateText(dataItem.itemState) }}
        </ng-template>
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column" let-filterService="filterService">
          <select
            class="form-select form-select-sm"
            [ngModel]="getItemStateFilterValue(filter, column.field)"
            (ngModelChange)="onItemStateFilterChange($event, filterService, filter, column.field)">
            <option value="">All</option>
            <option *ngFor="let option of itemStateOptions" [value]="option.value">{{ option.text }}</option>
          </select>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="originSource" title="Origin source" [width]="100">
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
          <kendo-grid-string-filter-cell
            [column]="column"
            [filter]="filter"
            operator="contains"
            [showOperators]="false">
          </kendo-grid-string-filter-cell>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="publishingSource" title="Publishing source">
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
          <kendo-grid-string-filter-cell
            [column]="column"
            [filter]="filter"
            operator="contains"
            [showOperators]="false">
          </kendo-grid-string-filter-cell>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="isReplaced" title="Is replaced" [filterable]="true" [width]="80">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.isReplaced ? 'YES' : 'NO' }}
        </ng-template>
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column" let-filterService="filterService">
          <select
            class="form-select form-select-sm"
            [ngModel]="getIsReplacedFilterValue(filter, column.field)"
            (ngModelChange)="onIsReplacedFilterChange($event, filterService, filter, column.field)">
            <option value="">All</option>
            <option *ngFor="let option of isReplacedOptions" [value]="option.value">{{ option.text }}</option>
          </select>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="lastModificationDateTime" title="Last modification date" [filterable]="false">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.lastModificationDateTime | date:'yyyy-MM-dd HH:mm:ss' }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="Actions" [filterable]="false" [width]="160">
        <ng-template kendoGridHeaderTemplate>
          <span>Actions</span>
          @if (isAdmin && selectedItems.length > 0) {
            <button class="btn btn-outline-secondary btn-sm ms-2" (click)="resendSelectedItems()" title="Resend selected ({{ selectedItems.length }})">
              <i class="fa fa-paper-plane" aria-hidden="true"></i> ({{ selectedItems.length }})
            </button>
          }
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          <button class="btn btn-outline-secondary btn-sm" style="margin-right: 5px;" (click)="viewItem(dataItem)" title="View">
            <i class="fa fa-magnifying-glass" aria-hidden="true"></i>
          </button>
          @if (isAdmin) {
            <button class="btn btn-outline-secondary btn-sm" style="margin-right: 5px;" (click)="editItem(dataItem)" title="Edit">
              <i class="fa fa-pencil" aria-hidden="true"></i>
            </button>
            <button class="btn btn-outline-secondary btn-sm" style="margin-right: 5px;" (click)="resendItem(dataItem)" title="Resend">
              <i class="fa fa-paper-plane" aria-hidden="true"></i>
            </button>
          }
          <button class="btn btn-outline-secondary btn-sm" (click)="viewSyncJson(dataItem)" title="View Sync JSON">
            <i class="fa fa-code" aria-hidden="true"></i>
          </button>
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>